/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { Link } from "gatsby"
import * as React from "react"

/* -------------------------------------------------------------------------- */
/*                                    Utils                                   */
/* -------------------------------------------------------------------------- */
import {
  essentialConsentTypes,
  grantGaConsent,
  nonEssentialConsentTypes,
} from "@utils/gtm"

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function CookieBanner(props) {
  return (
    <>
      <div className="bg-atlantic-blue-1 bottom-0 fixed [padding:29px_54px] w-full z-[100]">
        {/* Main Content */}
        <div className="grid gap-[32px] justify-items-center [margin-inline:auto] max-w-[1440px] w-full min-desktop4:grid-cols-[minmax(400px,521px)_1fr]">
          {/* Disclosure */}
          <div className="font-['Inter'] leading-[20px] max-w-[521px] text-[12px] text-grey-5 [&_a]:text-pacific-blue [&_a]:underline [&_a]:font-['Inter']">
            This website uses cookies to enhance user experience, to analyze
            performance, to track site usage, and to assist in marketing
            efforts. We also share this information with social media,
            advertising, and analytics partners. You can accept all cookies,
            decline non-essential cookies, or manage your preferences at any
            time. Learn more by reviewing our{" "}
            <Link to="/online-privacy-policy">Online Privacy Policy</Link>.
          </div>
          {/* Cookie Selection Container */}
          <div className="[--gap:21px] grid gap-[var(--gap)] items-center justify-items-center max-w-[521px] w-full min-desktop4:grid-cols-[auto_1fr] min-desktop4:max-w-full min-desktop4:[&_button]:w-full">
            <button
              className="button [padding:0] text-left text-pacific-blue underline hover:underline"
              onClick={() => props.openCookiePopup()}
            >
              Select Cookie Preferences
            </button>
            <div className="grid gap-[var(--gap)] min-desktop4:grid-cols-[repeat(2,1fr)] w-full">
              <button
                className="button button--primary w-full"
                onClick={() =>
                  props.storeConsentTypes(
                    essentialConsentTypes.concat(
                      nonEssentialConsentTypes.marketing,
                    ),
                  )
                }
              >
                Accept All Cookies
              </button>
              <button
                className="font-variant-numeric--primary font-semibold leading-[18px] text-[16px] text-grey-5"
                onClick={() => props.storeConsentTypes(essentialConsentTypes)}
              >
                Decline All Non-Essential Cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
